import { call, put, takeLatest } from "redux-saga/effects";
import {
  customerAddFailure,
  customerAddSuccess,
  customerDeleteFailure,
  customerDeleteSuccess,
  customerEditFailure,
  customerEditSuccess,
  customerSearchViewAllFailure,
  customerSearchViewAllSuccess,
  customerViewAllFailure,
  customerViewAllSuccess,
  customerViewFailure,
  customerViewSuccess,
} from "./CustomerAction";

import {
  CUSTOMER_ADD_REQUEST,
  CUSTOMER_DELETE_REQUEST,
  CUSTOMER_EDIT_REQUEST,
  CUSTOMER_SEARCH_REQUEST,
  CUSTOMER_VIEW_ALL_REQUEST,
  CUSTOMER_VIEW_REQUEST,
} from "./CustomerTypes";

import {
  AddCustomerEffect,
  DeleteCustomerEffect,
  EditCustomerEffect,
  ViewAllCustomerEffect,
  ViewAllSearchCustomersEffect,
  ViewCustomerEffect,
} from "./CustomerEffect";

// Add customer
function* addCustomerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(AddCustomerEffect, action.payload, config);
    yield put(customerAddSuccess, response.data);
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add bar/club";
    yield put(
      customerAddFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Edit customer
function* editCustomerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { id, updatedData } = action.payload;

    const response = yield call(EditCustomerEffect, id, updatedData, config);
    yield put(customerEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred.";
    yield put(customerEditFailure({ message, errorFields }));
  }
}

// View customer
function* viewCustomerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(ViewCustomerEffect, action.payload, config);
    yield put(customerViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to view bar/club";
    yield put(customerViewFailure({ errormessage: errorMessage }));
  }
}

// View all customers
function* viewAllCustomerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllCustomerEffect, action.payload, config);

    yield put(customerViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to view all bars/clubs";
    yield put(customerViewAllFailure({ errormessage: errorMessage }));
  }
}

// View All Search Customer
function* viewAllSearchCustomerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllSearchCustomersEffect, action.payload, config);

    yield put(customerSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(customerSearchViewAllFailure({ errormessage: errorMessage }));
  }
}


// Delete customer
function* deleteCustomerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(DeleteCustomerEffect, action.payload, config);
    yield put(customerDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete bar/club";
    yield put(customerDeleteFailure({ errormessage: errorMessage }));
  }
}

export function* CustomerSaga() {
  yield takeLatest(CUSTOMER_ADD_REQUEST, addCustomerSaga);
  yield takeLatest(CUSTOMER_EDIT_REQUEST, editCustomerSaga);
  yield takeLatest(CUSTOMER_VIEW_REQUEST, viewCustomerSaga);
  yield takeLatest(CUSTOMER_VIEW_ALL_REQUEST, viewAllCustomerSaga);
  yield takeLatest(CUSTOMER_DELETE_REQUEST, deleteCustomerSaga);
  yield takeLatest(CUSTOMER_SEARCH_REQUEST, viewAllSearchCustomerSaga);
}
